import React from "react";
import { useDrag, useDrop } from "react-dnd";
import classes from "./style.module.css";

const ItemType = "marker";

const DraggableMarker = ({ id, position, moveMarker }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemType,
      item: { id, type: ItemType, x: position.x, y: position.y },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [id, position]
  );

  const [, drop] = useDrop(
    () => ({
      accept: ItemType,
      hover: (item, monitor) => {
        const delta = monitor.getDifferenceFromInitialOffset();
        if (!delta) return;

        const newX = item.x + delta.x;
        const newY = item.y + delta.y;
        moveMarker(id, newX, newY);
      },
    }),
    [id, position]
  );

  return (
    <div
      ref={(node) => drag(drop(node))}
      className={classes.draggableContainer}
      style={{
        top: position.y - 40,
        left: position.x - 15,
        opacity: isDragging ? 0.5 : 1,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <div className={classes.draggableCircle}>{id}</div>
      <div className={classes.draggableCircleTriangle} />
    </div>
  );
};

export default DraggableMarker;
